// extracted by mini-css-extract-plugin
module.exports = {"textAndIcon":"Favourite_textAndIcon__rZJpZ","icon":"Favourite_icon__CG8rN","text":"Favourite_text__3G-dl"};